module.exports = __webpack_public_path__ + "img/ย้อนกลับไปตัวเลือกก่อนหน้า_ คลิกที่นี่.7f8fdd3a.svg";